import {DataPlugin, DisplayData, DisplayDataWidget} from "@me8eon/data";
import {OfficeBuddyDisplay, SimpleOfficeBuddyOneLineDisplay, SimpleOfficeBuddyWidget } from "./simple.officebuddy.display";

export const OfficeBuddyDataName = 'officeBuddy';
export type OfficeBuddyData = {
    id: number;
    urls: string;
    title_en: string;
    title_de: string;
    description_en: string;
    description_de: string;
    type: string;
    additional_keywords_en: string;
    additional_keywords_de: string;
    index: string;
}

export function OfficeBuddyDataPlugin(
    DisplayData: DisplayData<OfficeBuddyData> = OfficeBuddyDisplay,
    DisplayDataOneLine: DisplayData<OfficeBuddyData> = SimpleOfficeBuddyOneLineDisplay,
    DisplayDataWidget: DisplayDataWidget<OfficeBuddyData> = SimpleOfficeBuddyWidget): DataPlugin<OfficeBuddyData> {
    return {
        plugin: 'data',
        name: OfficeBuddyDataName,
        DisplayData,
        DisplayDataOneLine,
        DisplayDataWidget,
        idFrom: data => `${data.index}.${data.id}`
    };
}
